/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ level: NonNullable<unknown>, prestige: NonNullable<unknown> }} Leveling_Ladder_Level_In_PrestigeInputs */



/**
* | output |
* | --- |
* | "Level {level} in prestige {prestige}" |
*
* @param {Leveling_Ladder_Level_In_PrestigeInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_ladder_level_in_prestige = /** @type {((inputs: Leveling_Ladder_Level_In_PrestigeInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Ladder_Level_In_PrestigeInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`Уровень ${i?.level}, престиж ${i?.prestige}`)
	return /** @type {LocalizedString} */ (`Level ${i?.level} in prestige ${i?.prestige}`)
});